import React from 'react';
import CreativeBriefForm from './CreativeBriefForm';
import './App.css';

function App() {
  return <CreativeBriefForm />;
}

export default App;
